import { useLingui } from "@lingui/react/macro";
import { supplierApi } from "@/lib/api/services/supplier.api";
import type { Supplier } from "@/types/supplier";
import { EntitySelect } from "./EntitySelect";

export interface SupplierSelectProps {
  value: number | null | undefined;
  onChange: (value: number, supplier: Supplier) => void;
  onClear?: () => void;
  displayValue?: string;
  placeholder?: string;
  disabled?: boolean;
  triggerClassName?: string;
}

export function SupplierSelect({
  value,
  onChange,
  onClear,
  displayValue,
  placeholder,
  disabled,
  triggerClassName,
}: SupplierSelectProps) {
  const { t } = useLingui();
  return (
    <EntitySelect<Supplier>
      queryKeyBase={["entity-select", "suppliers"]}
      fetchPage={({ page, limit, search }) =>
        supplierApi.getAll({ page, limit, search: search || undefined })
      }
      getOptionValue={(s) => String(s.id)}
      getOptionLabel={(s) => s.name}
      fetchItem={(id) => supplierApi.getById(id)}
      value={value == null ? "" : String(value)}
      onChange={(val, supplier) => onChange(Number(val), supplier)}
      onClear={onClear}
      displayValue={displayValue}
      placeholder={placeholder ?? t`Select a supplier...`}
      searchPlaceholder={t`Search suppliers…`}
      emptyMessage={t`No suppliers found`}
      disabled={disabled}
      triggerClassName={triggerClassName}
    />
  );
}
